import Decision from "../Components/Decision";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import VolunteerRegisterForm from "./VolunteerRegisterForm";
import EventBanner from "./EventBanner";

export default function RegisterVolunteer() {
    return (
      <div>
        <Header/>
        <EventBanner/>
        <VolunteerRegisterForm />
        <Decision/>
        <Footer />
      </div>
    );
  }
